/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var dataLinks = document.querySelectorAll('.menu-step__links .nav-bar__link');
var getCountSelector = document.querySelector('.counter');
var backButton = document.querySelectorAll('.step-back-button');

dataLinks.forEach((link) => {
  link.addEventListener('click', (e) => {
    var getAttr = link.getAttribute('data-link');
    var getParent = link.closest('.menu-step__links').querySelectorAll('.menu-link');
  
    for (var i = 0; i < getParent.length; i++) {
      getParent[i].classList.remove('active');
      getParent[i].querySelectorAll('.nav-bar__link').forEach((link) => {
          link.classList.remove('active');
      });
    }
  
    e.target.classList.add('active');
  
    if (getAttr) {
      e.preventDefault();
      var matchAttr = document.querySelector(`.menu-link[data-handle="${getAttr}"]`);
      e.target.closest('.menu-link').classList.add('active');
      e.target.closest('.menu-step').style.display = 'none';

      var getCount = matchAttr.closest('.menu-step').getAttribute('data-step');
      getCountSelector.textContent = getCount;

      matchAttr.closest('.menu-step').style.display = 'block';
      matchAttr.classList.add('active');
      matchAttr.style.display = 'block';
    } else {
      e.target.closest('.menu-link').classList.add('active');
    }
  });
});


backButton.forEach((button) => {
  button.addEventListener('click', (bl) => {
    var getCount = bl.target.closest('.menu-step').getAttribute('data-step') - 1;
    var getParent = bl.target.closest('.menu-step');
    getCountSelector.textContent = getCount;
    bl.target.closest('.menu-step').style.display = 'none';
    getParent.querySelectorAll('.menu-link').forEach((pl) => {
      pl.classList.remove('active');
      pl.style.display = 'none';
      pl.querySelectorAll('.nav-bar__link').forEach((link) => {
          link.classList.remove('active');
      });
    });
  
    document.querySelector(`.menu-step[data-step="${getCount}"]`).style.display = 'block';
  });
})